export const frontmatter = {
    "title": "¿Qué es OnnIA?",
    "description": "OnnIA es la plataforma que unifica canales, agentes de IA y automatización para orquestar operaciones de principio a fin.",
    "sidebar_label": "¿Qué es OnnIA?",
    "sidebar_group": "conceptos",
    "sidebar_order": 1,
    "hide_title": true,
    "toc": false
}

export const toc = [
    {
        "depth": 2,
        "id": "los-tres-pilares",
        "value": "Los tres pilares"
    },
    {
        "depth": 2,
        "id": "el-problema-que-resuelve",
        "value": "El problema que resuelve"
    },
    {
        "depth": 2,
        "id": "como-funciona",
        "value": "Cómo funciona"
    },
    {
        "depth": 2,
        "id": "para-quien-es",
        "value": "¿Para quién es?"
    },
    {
        "depth": 2,
        "id": "la-ia-en-el-proceso",
        "value": "La IA en el proceso"
    }
]